import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Children, isValidElement } from 'react';
import { Container, Item } from './styled.js';
import { jsx } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
if (process.env.NODE_ENV !== "production") {
  // eslint-disable-next-line no-console
  console.warn('[DEPRECATED COMPONENT]: <Spacer /> is deprecated.');
}
function Spacer(props) {
  var _props$align = props.align,
    align = _props$align === void 0 ? 'start' : _props$align,
    _props$children = props.children,
    children = _props$children === void 0 ? undefined : _props$children,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'horizontal' : _props$direction,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? 2 : _props$spacing,
    _props$stretch = props.stretch,
    stretch = _props$stretch === void 0 ? false : _props$stretch,
    restProps = __rest(props, ["align", "children", "direction", "spacing", "stretch"]);
  function filteredChildren() {
    return Children.toArray(children).filter(function (child) {
      return /*#__PURE__*/isValidElement(child);
    }).map(function (child) {
      return /*#__PURE__*/jsx(Item, {
        $spacing: spacing,
        $stretch: stretch || child.props.stretch,
        $direction: direction,
        children: child
      }, child.key);
    });
  }
  return /*#__PURE__*/jsx(Container, _extends({}, restProps, {
    $spacing: spacing,
    $align: align,
    $direction: direction,
    children: filteredChildren()
  }));
}

export { Spacer as default };
